import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  clearErrors,
  saveAlternateRoyaltySettings,
} from 'bundles/backoffice/royalty_settings/store/alternate_royalty/actions';

import Modal from 'components/modal';
import { Alert } from 'components/ui/alert';
import { Button } from 'components/ui/button';
import ManagedInput from 'components/form/managed_input';
import ManagedFormGroup from 'components/form/managed_input/form_group';

export function AlternateRoyaltyModal({
  clearErrors,
  enabled,
  errors = [],
  royaltyPercent,
  saveAlternateRoyaltySettings,
  saving,
  show,
  onClose
}) {
  const [settings, setSettings] = useState({});
  const wasSaving = useRef(false);

  useEffect(() => {
    if (show) {
      setSettings({ enabled, royaltyPercent });
    }
  }, [enabled, royaltyPercent, show]);

  useEffect(() => {
    if (show) {
      clearErrors();
    }
  }, [show]);

  useEffect(() => {
    if (wasSaving.current && !saving && errors.length === 0) {
      onClose();
    }
    wasSaving.current = saving;
  }, [saving]);

  const handleChange = (changes) => {
    setSettings({ ...settings, ...changes });
  };

  const handleSave = () => {
    saveAlternateRoyaltySettings(settings);
  };

  const handleClose = () => {
    if (!saving) {
      onClose();
    }
  };

  return (
    <Modal
      show={show}
      onCancel={handleClose}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        Alternate Royalty
      </Modal.Header>

      <Modal.Body>
        {errors.length > 0 &&
          <Alert className="mb-3" name="errors" severity="destructive">
            {errors.join(', ')}
          </Alert>
        }

        <label className="form-label">Enable or Disable</label>
        <ManagedInput
          name="enabled"
          type="checkbox"
          value={settings.enabled}
          onChange={handleChange}
        >
          Check if this company can apply deposits at an alternate royalty rate
        </ManagedInput>

        <ManagedFormGroup
          className="mt-4"
          label="Royalty Percent"
          name="royaltyPercent"
          type="number"
          value={settings.royaltyPercent}
          onChange={handleChange}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button disabled={saving} name="cancel" variant="ghost" onClick={handleClose}>
          Cancel
        </Button>
        <Button disabled={saving} name="save" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

AlternateRoyaltyModal.propTypes = {
  clearErrors: PropTypes.func.isRequired,
  enabled: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  royaltyPercent: PropTypes.number,
  saveAlternateRoyaltySettings: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = ({ alternateRoyalty }) => ({
  enabled: alternateRoyalty.enabled,
  errors: alternateRoyalty.errors,
  royaltyPercent: alternateRoyalty.royaltyPercent,
  saving: alternateRoyalty.saving,
});

const mapDispatchToProps = {
  clearErrors,
  saveAlternateRoyaltySettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(AlternateRoyaltyModal);
